import { CLY_E_PV } from './const'
import { getAllUrlParameters } from './utils'

const currentCountlyPageviewSrc = document.currentScript?.src
const currentCountlyPageviewparams = getAllUrlParameters(currentCountlyPageviewSrc)
window.currentCountlyPageHistory = []

function trackRoute(route: string, search: string = '') {
  if (!currentCountlyPageviewSrc) {
    console.error('无法获取currentScript')
    return
  }

  window.currentCountlyPageSrc = route
  const preRoute = window.currentCountlyPageHistory[window.currentCountlyPageHistory.length - 1]

  const { appKey, name, pageviewWaitUserDetails, debug, ...restParams } = currentCountlyPageviewparams

  if (window[name || 'Countly']) {
    // 循环检查window.Countly.isUserDetailInit是否为true
    const toTrack = () => {
      debug && console.log('pv上报[route, preRoute, search, isTrackInited]', route, preRoute, search, window.Countly.isTrackInited)
      window[name || 'Countly'].add_business_event({
        key: CLY_E_PV,
        segmentation: {
          href: route,
          fromHref: preRoute || '',
          search: search, // ✅ 新增：search 字段
          ...restParams,
        },
      })
    }
    const waitUserDetailsTrack = () => {
      debug && console.log('用户信息是否初始化 isTrackInited', window.Countly.isTrackInited)
      if (!window.Countly.isTrackInited) {
        return setTimeout(waitUserDetailsTrack, 100)
      }
      toTrack()
    }
    if (pageviewWaitUserDetails) {
      waitUserDetailsTrack()
    } else {
      toTrack()
    }
  }
  window.currentCountlyPageHistory.push(route)
}

// ✅ 修改：包含 search 参数
function getRoute() {
  return window.location.pathname + window.location.search + window.location.hash
}

// ✅ 新增：获取 search 参数
function getSearch() {
  return window.location.search
}

interface RouteTracker {
  lastRoute: string
  lastSearch: string // ✅ 新增：记录上次的 search
  debounceTimer: number | null
}

const routeTracker: RouteTracker = {
  lastRoute: '',
  lastSearch: '', // ✅ 新增
  debounceTimer: null,
}

// ✅ 修改：添加 search 参数判断
function optimizedTrackRoute(newRoute: string, newSearch: string, source: string) {
  // 清除之前的防抖定时器
  if (routeTracker.debounceTimer) {
    clearTimeout(routeTracker.debounceTimer)
    routeTracker.debounceTimer = null
  }

  routeTracker.debounceTimer = setTimeout(() => {
    // 在防抖结束后重新获取最新的 route 和 search，确保拿到完整参数
    const latestRoute = getRoute()
    const latestSearch = getSearch()

    // 路由和 search 参数都未变化时不上报
    if (routeTracker.lastRoute === latestRoute && routeTracker.lastSearch === latestSearch) {
      routeTracker.debounceTimer = null
      return
    }

    try {
      routeTracker.lastRoute = latestRoute
      routeTracker.lastSearch = latestSearch
      trackRoute(latestRoute, latestSearch)
    } catch (error) {
      console.error('Route tracking error:', error)
    } finally {
      routeTracker.debounceTimer = null
    }
  }, 500) // 500ms 防抖，确保接口返回修正 search 后只上报最终正确的地址
}

export function initPv() {
  if (window.routeTrackerInitialized) return
  window.routeTrackerInitialized = true

  const originalPushState = history.pushState
  const originalReplaceState = history.replaceState

  // 重写 history 方法
  history.pushState = function (...args) {
    originalPushState.apply(this, args)
    optimizedTrackRoute(getRoute(), getSearch(), 'pushState') // ✅ 修改：传入 search
  }

  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args)
    optimizedTrackRoute(getRoute(), getSearch(), 'replaceState') // ✅ 修改：传入 search
  }

  // 事件监听器
  window.addEventListener('popstate', () => {
    optimizedTrackRoute(getRoute(), getSearch(), 'popstate') // ✅ 修改：传入 search
  })

  window.addEventListener('hashchange', () => {
    optimizedTrackRoute(getRoute(), getSearch(), 'hashchange') // ✅ 修改：传入 search
  })

  // 初始化路由跟踪 - 也走防抖逻辑，确保初始 URL 修正后只上报正确地址
  const initialRoute = getRoute()
  const initialSearch = getSearch()
  // 不再直接设置 lastRoute/lastSearch，让防抖逻辑统一处理
  optimizedTrackRoute(initialRoute, initialSearch, 'init')
}

initPv()